import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link2, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/contexts/AuthContext";
import { normalizeWebsite, saveWebsiteSetupIntent, websiteSetupDestination } from "@/lib/websiteSetup";

export const HeroScanForm = ({ inputRef }) => {
  const [website, setWebsite] = useState("");
  const [error, setError] = useState("");
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const submit = (event) => {
    event.preventDefault();
    try {
      const normalized = normalizeWebsite(website);
      saveWebsiteSetupIntent(normalized);
      navigate(websiteSetupDestination(user));
    } catch (failure) {
      setError(failure.message);
      inputRef.current?.focus();
    }
  };

  return <div className="hero-scan-form-wrap">
    <form className="hero-scan-form" onSubmit={submit} noValidate data-testid="hero-scan-form">
      <div className="hero-website-field">
        <Link2 aria-hidden="true"/>
        <label className="sr-only" htmlFor="hero-website">Website address</label>
        <Input ref={inputRef} id="hero-website" type="text" inputMode="url" autoComplete="url" autoCapitalize="none" spellCheck={false} value={website} onChange={(event) => { setWebsite(event.target.value); setError(""); }} placeholder="Enter your website URL..." maxLength={2048} required aria-invalid={Boolean(error)} aria-describedby={error ? "hero-website-error" : undefined} data-testid="hero-website-input"/>
      </div>
      <Button type="submit" disabled={loading} className="hero-scan-button" data-testid="hero-scan-button"><Search aria-hidden="true"/><span>Scan My Website</span></Button>
    </form>
    {error && <p id="hero-website-error" className="hero-scan-error" role="alert" data-testid="hero-website-error">{error}</p>}
  </div>;
};